export const IS_LOCAL = process.env.REACT_APP_IS_LOCAL === 'true';

export const PRODUCT_SLUGS = {
  HELIXA_CSM: 'helixa-csm',
  HX_ENGINE_UI: 'hx-engine-ui',
  AFFINITY_GLOBAL: 'affinity-global',
  AFFINITY_US: 'affinity-us',
  AFFINITY_US_GWI: 'affinity-us-gwi',
  AFFINITY_SM_US_GWI: 'affinity-sm-us-gwi',
  AFFINITY_SM_US_MRI: 'affinity-sm-us-mri',
  AFFINITY_SM_WW_GWI: 'affinity-sm-ww-gwi',
  AFFINITY_SM_GB_TGI: 'affinity-sm-gb-tgi',
  AFFINITY_WW_GWI_MED: 'affinity-ww-gwi-med',
  DOCUMENTATION: 'documentation',
};

export const ADDON_SLUGS = {
  AI_QUERY_BUILDER: 'ai_qb',
  GOLD_DIGGER_JSON_DOWNLOAD: 'dwnld',
  US_POPULATION_21_PLUS: 'us21+',
};

export const PRODUCT_ICONS = {
  products: {
    [PRODUCT_SLUGS.AFFINITY_GLOBAL]: 'country',
    [PRODUCT_SLUGS.AFFINITY_US]: 'usa',
    [PRODUCT_SLUGS.HELIXA_CSM]: 'support',
    [PRODUCT_SLUGS.AFFINITY_US_GWI]: 'usa',
    [PRODUCT_SLUGS.AFFINITY_SM_US_GWI]: 'usa',
    [PRODUCT_SLUGS.AFFINITY_SM_US_MRI]: 'usa',
    [PRODUCT_SLUGS.AFFINITY_SM_WW_GWI]: 'icon-country',
    [PRODUCT_SLUGS.AFFINITY_SM_GB_TGI]: 'uk',
    [PRODUCT_SLUGS.AFFINITY_WW_GWI_MED]: 'icon-country',
    [PRODUCT_SLUGS.DOCUMENTATION]: 'icon-ticket',
  },
};

export const PRODUCT_COLORS = {
  products: {
    [PRODUCT_SLUGS.AFFINITY_GLOBAL]: 'rgb(7, 131, 117)',
    [PRODUCT_SLUGS.AFFINITY_US]: 'rgb(91,83,223)',
    [PRODUCT_SLUGS.HELIXA_CSM]: 'rgb(23, 121, 204)',
    [PRODUCT_SLUGS.AFFINITY_US_GWI]: 'rgb(7, 131, 117)',
    [PRODUCT_SLUGS.AFFINITY_SM_US_GWI]: 'rgb(91, 83, 223)',
    [PRODUCT_SLUGS.AFFINITY_SM_US_MRI]: 'rgb(91, 83, 223)',
    [PRODUCT_SLUGS.AFFINITY_SM_WW_GWI]: 'rgb(91, 83, 223)',
    [PRODUCT_SLUGS.AFFINITY_WW_GWI_MED]: 'rgb(91, 83, 223)',
    [PRODUCT_SLUGS.AFFINITY_SM_GB_TGI]: 'rgb(225, 40, 87)',
    [PRODUCT_SLUGS.DOCUMENTATION]: 'rgb(225, 40, 87)',
  },
};

const PREFIX = IS_LOCAL ? 'localhost-' : 'develop-';
const SUFFIX_CSM = IS_LOCAL ? ':3004' : '';
const SUFFIX_ENGINE_UI = IS_LOCAL ? ':3005' : '';
const SUFFIX_COMMON = IS_LOCAL ? ':3006' : '';

export const PRODUCT_LINK = {
  develop: {
    [PRODUCT_SLUGS.AFFINITY_GLOBAL]: `${PREFIX}discovery-ww.helixa.ai${SUFFIX_COMMON}`,
    [PRODUCT_SLUGS.AFFINITY_US]: `${PREFIX}discovery-us.helixa.ai${SUFFIX_COMMON}`,
    [PRODUCT_SLUGS.AFFINITY_US_GWI]: `${PREFIX}discovery-us-gwi.helixa.ai${SUFFIX_COMMON}`,
    [PRODUCT_SLUGS.AFFINITY_SM_US_GWI]: `${PREFIX}discover-us-gwi.helixa.ai${SUFFIX_COMMON}`,
    [PRODUCT_SLUGS.AFFINITY_SM_US_MRI]: `${PREFIX}discover-us.helixa.ai${SUFFIX_COMMON}`,
    [PRODUCT_SLUGS.AFFINITY_SM_WW_GWI]: `${PREFIX}discover-global.helixa.ai${SUFFIX_COMMON}`,
    [PRODUCT_SLUGS.AFFINITY_WW_GWI_MED]: `${PREFIX}discovery-global.helixa.ai${SUFFIX_COMMON}`,
    [PRODUCT_SLUGS.AFFINITY_SM_GB_TGI]: `${PREFIX}discover-gb.helixa.ai${SUFFIX_COMMON}`,
    [PRODUCT_SLUGS.DOCUMENTATION]: 'helpdesk.telmarhelixa.com/en',
    [PRODUCT_SLUGS.HELIXA_CSM]: `${PREFIX}csm.helixa.ai${SUFFIX_CSM}`,
    [PRODUCT_SLUGS.HX_ENGINE_UI]: `${PREFIX}engine-ui.helixa.ai${SUFFIX_ENGINE_UI}`,
  },
  staging: {
    [PRODUCT_SLUGS.AFFINITY_GLOBAL]: 'staging-discovery-ww.helixa.ai',
    [PRODUCT_SLUGS.AFFINITY_US]: 'staging-discovery-us.helixa.ai',
    [PRODUCT_SLUGS.AFFINITY_US_GWI]: 'staging-discovery-us-gwi.helixa.ai',
    [PRODUCT_SLUGS.AFFINITY_SM_US_GWI]: 'staging-discover-us-gwi.helixa.ai',
    [PRODUCT_SLUGS.AFFINITY_SM_US_MRI]: 'staging-discover-us.helixa.ai',
    [PRODUCT_SLUGS.AFFINITY_SM_WW_GWI]: 'staging-discover-global.helixa.ai',
    [PRODUCT_SLUGS.AFFINITY_WW_GWI_MED]: 'staging-discovery-global.helixa.ai',
    [PRODUCT_SLUGS.AFFINITY_SM_GB_TGI]: 'staging-discover-gb.helixa.ai',
    [PRODUCT_SLUGS.DOCUMENTATION]: 'helpdesk.telmarhelixa.com/en',
    [PRODUCT_SLUGS.HELIXA_CSM]: 'staging-csm.helixa.ai',
    [PRODUCT_SLUGS.HX_ENGINE_UI]: 'staging-engine-ui.helixa.ai',
  },
  production: {
    [PRODUCT_SLUGS.AFFINITY_GLOBAL]: 'discovery-ww.helixa.ai',
    [PRODUCT_SLUGS.AFFINITY_US]: 'discovery-us.helixa.ai',
    [PRODUCT_SLUGS.AFFINITY_US_GWI]: 'discovery-us-gwi.helixa.ai',
    [PRODUCT_SLUGS.AFFINITY_SM_US_GWI]: 'discover-us-gwi.helixa.ai',
    [PRODUCT_SLUGS.AFFINITY_SM_US_MRI]: 'discover-us.helixa.ai',
    [PRODUCT_SLUGS.AFFINITY_SM_WW_GWI]: 'discover-global.helixa.ai',
    [PRODUCT_SLUGS.AFFINITY_WW_GWI_MED]: 'discovery-global.helixa.ai',
    [PRODUCT_SLUGS.AFFINITY_SM_GB_TGI]: 'discover-gb.helixa.ai',
    [PRODUCT_SLUGS.DOCUMENTATION]: 'helpdesk.telmarhelixa.com/en',
    [PRODUCT_SLUGS.HELIXA_CSM]: 'csm.helixa.ai',
    [PRODUCT_SLUGS.HX_ENGINE_UI]: 'engine-ui.helixa.ai',
  },
};
